import { BasicFields } from './common'
import { FileInterface } from './file'

export enum CATEGORY_TYPE {
  Fruit = 'Fruit',
  Other = 'Other'
}

export interface CategoryDetailInterface extends BasicFields {
  categoryId: string
  sequentialNo: number
  name: string
  type?: keyof typeof CATEGORY_TYPE | ''
  remark?: string
  imageFileId?: string
  blogUrl?: string
  imageFile?: FileInterface
}

export type CategoryListInterface = Pick<
  CategoryDetailInterface,
  | 'categoryId'
  | 'sequentialNo'
  | 'name'
  | 'type'
  | 'createdTime'
  | 'updatedTime'
  | 'updatedByEmail'
>

export type CategoryFormInterface = Pick<
  CategoryDetailInterface,
  'name' | 'type' | 'remark' | 'imageFile' | 'blogUrl'
>

export interface CreateCategoryInputInterface
  extends Pick<
    CategoryDetailInterface,
    'name' | 'type' | 'remark' | 'blogUrl'
  > {
  imageFileId?: string | null
}

export interface UpdateCategoryInputInterface
  extends Pick<
    CategoryDetailInterface,
    'name' | 'type' | 'remark' | 'blogUrl'
  > {
  imageFileId?: string | null
}

export interface CategorySearchResponse {
  categoryId: string
  name: string
}
